import { render, staticRenderFns } from "./PageScalingCard.vue?vue&type=template&id=6a850e9e&scoped=true"
import script from "./PageScalingCard.vue?vue&type=script&lang=ts"
export * from "./PageScalingCard.vue?vue&type=script&lang=ts"
import style0 from "./PageScalingCard.vue?vue&type=style&index=0&id=6a850e9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a850e9e",
  null
  
)

export default component.exports